"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompoundLabel = exports.dataLabel = exports.DataLabels = void 0;
exports.isCompoundLabel = isCompoundLabel;
exports.combineLabels = combineLabels;
const typegate_1 = require("typegate");
exports.DataLabels = {
    Unknown: 'Unknown',
    KnownSafe: 'KnownSafe',
    PII: 'PII',
    PHI: 'PHI',
    IdentifiablePHI: 'IdentifiablePHI',
    RecordId: 'RecordId',
    RecordUUID: 'RecordUUID',
    ReferenceNumber: 'ReferenceNumber',
    ExternalStringId: 'ExternalStringId',
    PostalCode: 'PostalCode',
    DateOfBirth: 'DateOfBirth',
    IdentifiableDate: 'IdentifiableDate',
    NonIdentifiableDate: 'NonIdentifiableDate',
    FreeFormText: 'FreeFormText',
    AgeAtServiceTime: 'AgeAtServiceTime',
    Language: 'Language',
    LiveAnswers: 'LiveAnswers',
    LiveEncryptedAnswers: 'LiveEncryptedAnswers',
    ArchivedAnswers: 'ArchivedAnswers',
    ArchivedEncryptedAnswers: 'ArchivedEncryptedAnswers',
    SensitiveSystemData: 'SensitiveSystemData',
    AdvisorEmail: 'AdvisorEmail',
    LoginEmail: 'LoginEmail',
    InsuredPersonEmail: 'InsuredPersonEmail',
    LeadEmail: 'LeadEmail',
    Email: 'Email',
    SystemTimestamp: 'SystemTimestamp',
    EncryptedData: 'EncryptedData',
};
exports.dataLabel = typegate_1.t.union(typegate_1.t.literal('Unknown'), typegate_1.t.literal('KnownSafe'), typegate_1.t.literal('PII'), typegate_1.t.literal('PHI'), typegate_1.t.literal('IdentifiablePHI'), typegate_1.t.literal('RecordId'), typegate_1.t.literal('RecordUUID'), typegate_1.t.literal('ReferenceNumber'), typegate_1.t.literal('ExternalStringId'), typegate_1.t.literal('PostalCode'), typegate_1.t.literal('DateOfBirth'), typegate_1.t.literal('IdentifiableDate'), typegate_1.t.literal('NonIdentifiableDate'), typegate_1.t.literal('FreeFormText'), typegate_1.t.literal('AgeAtServiceTime'), typegate_1.t.literal('Language'), typegate_1.t.literal('LiveAnswers'), typegate_1.t.literal('LiveEncryptedAnswers'), typegate_1.t.literal('ArchivedAnswers'), typegate_1.t.literal('ArchivedEncryptedAnswers'), typegate_1.t.literal('SensitiveSystemData'), typegate_1.t.literal('AdvisorEmail'), typegate_1.t.literal('LoginEmail'), typegate_1.t.literal('InsuredPersonEmail'), typegate_1.t.literal('LeadEmail'), typegate_1.t.literal('Email'), typegate_1.t.literal('SystemTimestamp'), typegate_1.t.literal('EncryptedData'));
class CompoundLabel {
    labels;
    constructor(labels) {
        this.labels = labels;
    }
}
exports.CompoundLabel = CompoundLabel;
function isCompoundLabel(label) {
    return label instanceof CompoundLabel;
}
function combineLabels(...dataLabels) {
    const labels = [];
    for (const dataLabel of dataLabels) {
        if (isCompoundLabel(dataLabel)) {
            labels.push(...dataLabel.labels);
        }
        else {
            labels.push(dataLabel);
        }
    }
    return new CompoundLabel(labels);
}
